import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {ProductColumn, UnitFormatter} from "../../../utils/formatters";

class ProductionList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
            props.view = [...props.view, "product_id"];
        } else {
            props.view = ["product_id"];
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "ProductionList"}
                {...props}
                columns={{
                    "id": {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...((!(this.props.presets || {}).product_id) ? {"product.displayname": {...ProductColumn("product_id"), width: 4}} : {}),
                    "qty": {header: 'Darabszám', className: "unit", renderer: (value, row) => UnitFormatter(value, row.unit), width: 4, sortable, filterable},
                    "productiondate": {header: 'Gyártás dátuma', width: 4, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ProductionList;
